import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import Modal from 'react-bootstrap/Modal';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

import {
    CitySelect,
    CountrySelect,
    StateSelect,
    LanguageSelect,
    RegionSelect,
    PhonecodeSelect
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

function LaboratoryLists({ serverUrl, user, titleOfPage, globalUserId, globalToken   }) {
    const [region, setRegion] = useState("");
    const [phonecode, setPhoneCode] = useState("");
    const [countryid, setCountryid] = useState(101);
    const [stateid, setstateid] = useState(0);

    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();
    const [yearFilter, setYearFilter] = useState("all")
    const [labFilter, setLabFilter] = useState("all")

    const [labViewMode, setLabViewMode] = useState("View");
    const [viewIndividualLab, setViewIndividualLab] = useState(false);

    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [gst, setGst] = useState("");
    const [pan, setPan] = useState("");
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [pinCode, setPinCode] = useState("");
    const [country, setCountry] = useState({
        "id": 101,
        "name": "India",
        "iso3": "IND",
        "iso2": "IN",
        "numeric_code": "356",
        "phone_code": "91",
        "capital": "New Delhi",
        "currency": "INR",
        "currency_name": "Indian rupee",
        "currency_symbol": "₹",
        "tld": ".in",
        "native": "भारत",
        "region": "Asia",
        "subregion": "Southern Asia",
        "latitude": "20.00000000",
        "longitude": "77.00000000",
        "emoji": "🇮🇳"
    });
    const [contactPersonPhone, setContactPersonPhone] = useState("");
    const [contactPersonName, setContactPersonName] = useState("")
    const [allocateStock, setAllocateStock] = useState(0);
    const [stockCalculation, setStockCalculation] = useState(0);
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [picture, setPicture] = useState("");
    const [warrantyCardInhand, setStockInHand] = useState(0);
    const [warrantyCardUsed, setWarrantyCardUsed] = useState(0);
    const [salesOfCrown, setSalesOfCrown] = useState(0);
    const [registeredOn, setRegisteredOn] = useState("");
    const [password, setPassword] = useState("");
    const [settings, setSettings] = useState({});

    const [captcha, setCaptcha] = useState("");

    const [allLabs, setAllLabs] = useState([]);

    const [editLabData, setEditLabData] = useState({});

    const [labView, setLabView] = useState([]);

    const addLab = async (e) => {
        e.preventDefault()

        const query = {
            "code": code,
            "name": name,
            "gst": gst,
            "pan": pan,
            "address": address,
            "city": city,
            "state": state,
            "pinCode": pinCode,
            "country": country,
            "contactPersonPhone": contactPersonPhone,
            "contactPersonName": contactPersonName,
            "allocateStock": allocateStock,
            "stockCalculation": stockCalculation,
            "phone": phone,
            "email": email,
            "picture": picture ? picture : "",
            "warrantyCardInhand": allocateStock,
            "warrantyCardUsed": warrantyCardUsed,
            "salesOfCrown": salesOfCrown,
            "registeredOn": new Date(),
            "userId": code,
            "password": password,
            "settings": settings
        }
        const saveTheLab = await axios.post(serverUrl + "/labs/add", query);
        if (saveTheLab.status == 200) {
            // console.log(saveTheLab.data)
            updateLog({ "Name": "New Lab Added", "Lab code": code, "Details": query })
            resetAll();
            setLabViewMode("View");
            getAllLabs();
        } else {
            console.log(saveTheLab.data)
        }
    }
    const editLab = async (e) => {
        e.preventDefault();
        const query = {
            "code": editLabData.code,
            "name": name,
            "gst": gst,
            "pan": pan,
            "address": address,
            "city": city,
            "state": state,
            "pinCode": pinCode,
            "country": country,
            "contactPersonPhone": contactPersonPhone,
            "contactPersonName": contactPersonName,
            "allocateStock": allocateStock,
            "stockCalculation": stockCalculation,
            "phone": phone,
            "email": email,
            "picture": editLabData.picture ? editLabData.picture : "",
            "warrantyCardInhand": editLabData.warrantyCardInhand,
            "warrantyCardUsed": editLabData.warrantyCardUsed,
            "salesOfCrown": editLabData.salesOfCrown,
            "registeredOn": editLabData.registeredOn,
            "password": password,
            "settings": settings
        }
        const saveTheLab = await axios.post(serverUrl + "/labs/edit", query);
        if (saveTheLab.status == 200) {
            // console.log(saveTheLab.data)
            delete editLabData._id
            delete editLabData.updatedAt
            delete editLabData.createdAt
            query["previousData"] = editLabData
            updateLog({ "Name": "Lab Edited", "Lab code": editLabData.code, "Details": query })
            resetAll();
            setLabViewMode("View");
            getAllLabs();
        } else {
            console.log(saveTheLab.data)
        }
    }

    const resetAll = () => {
        setCode("");
        setName("");
        setGst("");
        setPan("");
        setAddress("");
        setCity("");
        setState("");
        setPinCode("");
        setCountry("");
        setContactPersonPhone("");
        setContactPersonName("");
        setAllocateStock("");
        setStockCalculation("");
        setPhone("");
        setEmail("");
        setPicture("");
        setStockInHand("");
        setWarrantyCardUsed("");
        setSalesOfCrown("");
        setRegisteredOn("");
        setSettings("");
        setPassword(uuidv4().split("-")[0]);
    }

    const getGSTDetails = async () => {
        const query = {
            "gstin": gst,
            "captcha": captcha
        }
        const getDetails = await axios.post("https://services.gst.gov.in/services/api/search/taxpayerDetails", query)

        if (getDetails.status == 200) {
            console.log(getDetails.data)
        }
    }

    const getLastId = async () => {
        const getLastLabCode = await axios.post(serverUrl + "/labs/getLastLab");

        if (getLastLabCode.status == 200) {
            setCode(getLastLabCode.data)
        } else {
            setCode("DD0001")
        }
    }

    const getAllLabs = async () => {
        const getAllLabs = await axios.post(serverUrl + "/labs/get", { code: "all" });
        if (getAllLabs.status == 200) {
            setAllLabs(getAllLabs.data);
        } else {
            console.log("No Data Found");
        }
    }

    const getLabData = async (code) => {
        const getAllLabs = await axios.post(serverUrl + "/labs/get", { code: code });
        if (getAllLabs.status == 200) {
            const chosenLab = getAllLabs.data[0]
            // console.log(chosenLab)
            setEditLabData(chosenLab);
            setCode(chosenLab.code);
            setName(chosenLab.name);
            setGst(chosenLab.gst);
            setPan(chosenLab.pan);
            setAddress(chosenLab.address);
            setCity(chosenLab.city);
            setState(chosenLab.state);
            setstateid(chosenLab.state.id)
            setPinCode(chosenLab.pinCode);
            setCountry(chosenLab.country);
            setContactPersonPhone(chosenLab.contactPersonPhone);
            setContactPersonName(chosenLab.contactPersonName);
            setAllocateStock(chosenLab.allocateStock);
            setStockCalculation(chosenLab.stockCalculation);
            setPhone(chosenLab.phone);
            setEmail(chosenLab.email);
            setPicture(chosenLab.picture);
            setStockInHand(chosenLab.warrantyCardInhand ? chosenLab.warrantyCardInhand : "0");
            setWarrantyCardUsed(chosenLab.warrantyCardUsed ? chosenLab.warrantyCardUsed : "0");
            setSalesOfCrown(chosenLab.salesOfCrown ? chosenLab.salesOfCrown : "0");
            setRegisteredOn(chosenLab.registeredOn);
            setSettings(chosenLab.settings);
            setPassword(chosenLab.password);

        } else {
            console.log("No Data Found");
        }
    }

    const viewLab = async (code) => {
        const viewItem = allLabs.filter((lab) => { return lab.code === code });
        setLabView(viewItem)
    }

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }



    useEffect(() => {
        setPassword(uuidv4().split("-")[0]);
        getLastId()
        getAllLabs()
    }, [])

    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                {
                    labViewMode === "New" ?
                        <>
                            <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>Create New Lab</div>
                            <div className='p-2 p-md-3 p-lg-3 overflow-auto rounded-0 h-100'>
                                <form action="" onSubmit={(e) => { addLab(e); }}>
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Lab Code</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100' readOnly value={code} style={{ maxWidth: "300px" }} onInput={(e) => { setCode(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Lab Name</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100' value={name} style={{ maxWidth: "300px" }} onInput={(e) => { setName(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">GST Number</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100 text-uppercase' minLength={15} maxLength={15} value={gst} style={{ maxWidth: "300px" }} onInput={(e) => { setGst(e.target.value.toUpperCase()); if (e.target.value.length < 15) { setPan("") } else { setPan(e.target.value.slice(2, 12).toUpperCase()); } }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Pan No.</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100 text-uppercase' value={pan} style={{ maxWidth: "300px" }} readOnly onInput={(e) => { setPan(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                {
                                                    pan ?
                                                        <div className="container-fluid">
                                                            <div className="row">
                                                                <div className="col-4 col-sm-3 d-flex align-items-center">Captcha</div>
                                                                <div className="col-8 col-sm-9 d-flex align-items-start justify-content-start flex-column gap-2">
                                                                    <img className='w-100' src={"https://services.gst.gov.in/services/captcha?rnd=0.67072381554045"} style={{ maxWidth: "300px" }} alt="captcha Image" />
                                                                    <span className='d-flex'>
                                                                        <input type="text" className='customFieldForDence w-100' value={captcha} onInput={(e) => { setCaptcha(e.target.value); }} />
                                                                        <button className='themeButtons px-3 ' onClick={() => { getGSTDetails() }}>Verify</button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        :
                                                        ""
                                                }
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">

                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 themeTextColor fs-5 my-3">
                                                Details of Contact Person
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Phone</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="tel" required className='customFieldForDence w-100' value={phone} style={{ maxWidth: "300px" }} onInput={(e) => { setPhone(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Email</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="email" required className='customFieldForDence w-100' value={email} style={{ maxWidth: "300px" }} onInput={(e) => { setEmail(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Address</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <textarea required className='customFieldForDence w-100' value={address} style={{ maxWidth: "300px" }} onInput={(e) => { setAddress(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Country</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center" style={{ pointerEvents: "none" }}>
                                                            <CountrySelect
                                                                inputClassName=" w-100"
                                                                containerClassName='customFieldForDence maxWidth300'
                                                                defaultValue={{
                                                                    "id": 101,
                                                                    "name": "India",
                                                                    "iso3": "IND",
                                                                    "iso2": "IN",
                                                                    "numeric_code": "356",
                                                                    "phone_code": "91",
                                                                    "capital": "New Delhi",
                                                                    "currency": "INR",
                                                                    "currency_name": "Indian rupee",
                                                                    "currency_symbol": "₹",
                                                                    "tld": ".in",
                                                                    "native": "भारत",
                                                                    "region": "Asia",
                                                                    "subregion": "Southern Asia",
                                                                    "latitude": "20.00000000",
                                                                    "longitude": "77.00000000",
                                                                    "emoji": "🇮🇳"
                                                                }}
                                                                onChange={(e) => {
                                                                    setCountryid(e.id);
                                                                    setCountry(e)
                                                                }}
                                                                placeHolder="Select Country"
                                                            />
                                                            {/* <input type="text" required className='customFieldForDence w-100' value={country} style={{ maxWidth: "300px" }} onInput={(e) => { setCountry(e.target.value) }} /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-start pt-1">State</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <StateSelect
                                                                inputClassName="w-100"
                                                                containerClassName='customFieldForDence maxWidth300'
                                                                countryid={countryid}
                                                                onChange={(e) => {
                                                                    setstateid(e.id);
                                                                    setState(e)
                                                                }}
                                                                placeHolder="Select State"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">City</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <CitySelect
                                                                inputClassName=" w-100"
                                                                containerClassName='customFieldForDence maxWidth300'
                                                                countryid={countryid}
                                                                stateid={stateid}
                                                                showFlag={true}
                                                                onChange={(e) => {
                                                                    setCity(e)
                                                                }}
                                                                placeHolder="Select City"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Pin Code</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="number" required className='customFieldForDence w-100' min={0} value={pinCode} style={{ maxWidth: "300px" }} onInput={(e) => { setPinCode(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Contact Person Phone</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100' value={contactPersonPhone} style={{ maxWidth: "300px" }} onInput={(e) => { setContactPersonPhone(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                {/* <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Allocate Warranty Card</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="number" required className='customFieldForDence w-100' value={allocateStock} style={{ maxWidth: "300px" }} onInput={(e) => { setAllocateStock(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Contact Person Name</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100' value={contactPersonName} style={{ maxWidth: "300px" }} onInput={(e) => { setContactPersonName(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 themeTextColor fs-5 my-3">
                                                Set Credentials for User
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">User ID</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100' readOnly defaultValue={code} style={{ maxWidth: "300px" }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-4 col-sm-3 d-flex align-items-center">Password</div>
                                                        <div className="col-8 col-sm-9 d-flex align-items-center">
                                                            <input type="text" required className='customFieldForDence w-100' value={password} style={{ maxWidth: "300px" }} onInput={(e) => { setPassword(e.target.value) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col d-flex justify-content-between gap-3">
                                                <button
                                                    type='button'
                                                    className='btn btn-secondary px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                                        setLabViewMode("View");
                                                        getAllLabs()
                                                        resetAll();
                                                    }}>Back to All Labs</button>
                                                <input type="submit" value="Create" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </>
                        :
                        labViewMode === "Edit" ?
                            <>
                                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>Edit Lab</div>
                                <div className='p-2 p-md-3 p-lg-3 overflow-auto rounded-0 h-100'>
                                    <form action="" onSubmit={(e) => { editLab(e); }}>
                                        {
                                            editLabData.code ?
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Lab Code</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' readOnly value={editLabData.code} style={{ maxWidth: "300px" }} onInput={(e) => { setCode(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Lab Name</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' defaultValue={editLabData.name} style={{ maxWidth: "300px" }} onInput={(e) => { setName(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">GST Number</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' defaultValue={editLabData.gst} style={{ maxWidth: "300px" }} onInput={(e) => { setGst(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Pan No.</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' defaultValue={editLabData.pan} style={{ maxWidth: "300px" }} onInput={(e) => { setPan(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 themeTextColor fs-5 my-3">
                                                            Details of Contact Person
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Phone</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="tel" required className='customFieldForDence w-100' defaultValue={editLabData.phone} style={{ maxWidth: "300px" }} onInput={(e) => { setPhone(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Email</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="email" required className='customFieldForDence w-100' defaultValue={editLabData.email} style={{ maxWidth: "300px" }} onInput={(e) => { setEmail(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-start pt-1">Address</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <textarea required className='customFieldForDence w-100' value={address} style={{ maxWidth: "300px" }} onInput={(e) => { setAddress(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Country</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center" style={{ pointerEvents: "none" }}>
                                                                        <CountrySelect
                                                                            inputClassName=" w-100"
                                                                            containerClassName='customFieldForDence maxWidth300'
                                                                            defaultValue={editLabData.country}
                                                                            onChange={(e) => {
                                                                                setCountryid(e.id);
                                                                                console.log(e)
                                                                            }}
                                                                            placeHolder="Select Country"
                                                                        />
                                                                        {/* <input type="text" required className='customFieldForDence w-100' value={country} style={{ maxWidth: "300px" }} onInput={(e) => { setCountry(e.target.value) }} /> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-start pt-1">State</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <StateSelect
                                                                            inputClassName=" w-100"
                                                                            containerClassName='customFieldForDence maxWidth300'
                                                                            countryid={countryid}
                                                                            defaultValue={editLabData.state}
                                                                            onChange={(e) => {
                                                                                setstateid(e.id);
                                                                                setState(e.name)
                                                                            }}
                                                                            placeHolder="Select State"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">City</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <CitySelect
                                                                            inputClassName=" w-100"
                                                                            containerClassName='customFieldForDence maxWidth300'
                                                                            countryid={countryid}
                                                                            stateid={stateid}
                                                                            placeholder='City'
                                                                            showFlag={true}
                                                                            defaultValue={editLabData.city}
                                                                            onChange={(e) => {
                                                                                setCity(e.name)
                                                                            }}
                                                                            placeHolder="Select City"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Pin Code</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="number" required className='customFieldForDence w-100' min={0} defaultValue={editLabData.pinCode} style={{ maxWidth: "300px" }} onInput={(e) => { setPinCode(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Contact Person Phone</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' defaultValue={editLabData.contactPersonPhone} style={{ maxWidth: "300px" }} onInput={(e) => { setContactPersonPhone(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            {/* <div className="container-fluid">
                                                        <div className="row">
                                                            <div className="col-4 col-sm-3 d-flex align-items-center">Allocate Warranty Card</div>
                                                            <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                <input type="number" required className='customFieldForDence w-100' defaultValue={editLabData.allocateStock} style={{ maxWidth: "300px" }} onInput={(e) => { setAllocateStock(e.target.value) }} />
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Contact Person Name</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' defaultValue={editLabData.contactPersonName} style={{ maxWidth: "300px" }} onInput={(e) => { setContactPersonName(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 themeTextColor fs-5 my-3">
                                                            Set Credentials for User
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">User ID</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' readOnly defaultValue={editLabData.code} style={{ maxWidth: "300px" }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3 d-flex align-items-center">Password</div>
                                                                    <div className="col-8 col-sm-9 d-flex align-items-center">
                                                                        <input type="text" required className='customFieldForDence w-100' defaultValue={editLabData.password} style={{ maxWidth: "300px" }} onInput={(e) => { setPassword(e.target.value) }} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col d-flex justify-content-between gap-3">
                                                            <button
                                                                type='button'
                                                                className='btn btn-secondary px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                                                    setLabViewMode("View");
                                                                    getAllLabs()
                                                                    resetAll();
                                                                }}>Back to All Labs</button>
                                                            <input type="submit" value="Update" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="container-fluid">
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 themeTextColor fs-5 my-3">
                                                            Details of Contact Person
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 themeTextColor fs-5 my-3">
                                                            Set Credentials for User
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-12 col-lg-6 col-xl-6 mb-3">
                                                            <div className="container-fluid">
                                                                <div className="row">
                                                                    <div className="col-4 col-sm-3">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                    <div className="col-8 col-sm-9">
                                                                        <SkeletonTheme highlightColor='#d8733934'>
                                                                            <Skeleton height={35} className=' w-100' style={{ maxWidth: "300px" }} />
                                                                        </SkeletonTheme>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col d-flex justify-content-between gap-3">
                                                            <SkeletonTheme highlightColor='#d8733934'>
                                                                <Skeleton height={35} className='px-5 py-3 rounded-pill' />
                                                                <Skeleton height={35} className='px-5 py-3 rounded-pill' />
                                                            </SkeletonTheme>
                                                        </div>
                                                    </div>
                                                </div>
                                        }
                                    </form>
                                </div>
                            </>
                            :
                            labViewMode === "View" ?
                                <>
                                    <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                                    <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>

                                        <div className='mb-3 d-flex gap-3 justify-content-between  flex-wrap'>
                                            <div className='d-flex gap-5 flex-wrap'>
                                                <button className='themeButtons px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                                                    setLabViewMode("New");
                                                    getLastId();
                                                }}>Add Lab</button>
                                            </div>
                                            <div className='d-flex gap-5 flex-wrap'>
                                                <CSVDownloader
                                                    type={Type.Button}
                                                    filename={'LaboratoryList'}
                                                    bom={true}
                                                    config={{
                                                        delimiter: ',',
                                                    }}
                                                    className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                                    data={
                                                        jsonToCSV(allLabs)
                                                    }
                                                >
                                                    Export to Excel
                                                </CSVDownloader>
                                            </div>
                                        </div>
                                        <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                                            <span>
                                                Total Records:
                                            </span>
                                            {
                                                allLabs.length > 0 ?
                                                    allLabs.length
                                                    :
                                                    "0"
                                            }
                                        </div>
                                        <div className='overflow-auto'>
                                            <table className='table table-light table-bordered w-100 table-striped m-0'>
                                                <thead className='thead-dark'>
                                                    <tr align="center" className='sticky-top'>
                                                        <th valign='middle'><span className='text-nowrap'>Lab Code</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Lab Name</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Phone</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Email</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Warranty Card InHand</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Warranty Card Used</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Sales of Crowns</span></th>
                                                        <th valign='middle'><span className='text-nowrap'>Registered On</span></th>
                                                        <th valign='middle' width="1%"><span className='text-nowrap'>Options</span></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        allLabs.length > 0 ?
                                                            allLabs.map((data, key) => {
                                                                return (
                                                                    <tr className='text-center' key={key}>
                                                                        <td valign='middle'>{data.code}</td>
                                                                        <td valign='middle'>{data.name}</td>
                                                                        <td valign='middle'>{data.phone}</td>
                                                                        <td valign='middle'>{data.email}</td>
                                                                        <td valign='middle'>{data.warrantyCardInhand ? data.warrantyCardInhand : 0}</td>
                                                                        <td valign='middle'>{data.warrantyCardUsed ? data.warrantyCardUsed : 0}</td>
                                                                        <td valign='middle'>{data.salesOfCrown ? data.salesOfCrown : 0}</td>
                                                                        <td valign='middle'>{data.registeredOn}</td>
                                                                        <td valign='middle'>
                                                                            <div className='d-flex gap-2 align-items-center'>
                                                                                <button className='btn btn-sm btn-secondary px-3 py-1 rounded w-100' onClick={(e) => { setViewIndividualLab(true); viewLab(data.code) }}>View</button>
                                                                                <button className='themeButtons px-3 py-1 rounded w-100' onClick={() => { setLabViewMode("Edit"); getLabData(data.code); }}>Edit</button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>

                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td valign='middle' colSpan={9}>
                                                                    <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold text-center">
                                                                        No Data
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className="alert alert-danger text-center fs-6">
                                    Unknown View
                                </div>
                }

            </div>

            <Modal
                show={viewIndividualLab}
                onHide={() => { setViewIndividualLab(false); setEditLabData({}) }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            LAB Code: {labView[0]?.code}
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='overflow-auto d-flex flex-column rounded-0 h-100'>
                        <table className='table table-light table-bordered w-100 table-striped m-0'>
                            <thead className='thead-dark'>
                                <tr align="center" className='sticky-top'>
                                    <th valign='middle'>Lab Code</th>
                                    <th valign='middle'>Lab Name</th>
                                    <th valign='middle'>Phone</th>
                                    <th valign='middle'>Email</th>
                                    <th valign='middle'>Stock InHand</th>
                                    <th valign='middle'>Stock Used</th>
                                    <th valign='middle'>Barcode Used</th>
                                    <th valign='middle'>Registered On</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    labView.length > 0 ?
                                        labView.map((data, key) => {
                                            return (
                                                <tr className='text-center' key={key}>
                                                    <td valign='middle'>{data.code}</td>
                                                    <td valign='middle'>{data.name}</td>
                                                    <td valign='middle'>{data.phone}</td>
                                                    <td valign='middle'>{data.email}</td>
                                                    <td valign='middle'>{data.warrantyCardInhand ? data.warrantyCardInhand : 0}</td>
                                                    <td valign='middle'>{data.warrantyCardUsed ? data.warrantyCardUsed : 0}</td>
                                                    <td valign='middle'>{data.salesOfCrown ? data.salesOfCrown : 0}</td>
                                                    <td valign='middle'>{data.registeredOn}</td>
                                                </tr>

                                            )
                                        }) :
                                        <tr>
                                            <td valign='middle' colSpan={8}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold text-center">
                                                    No Data
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center'>
                        <input type="submit" value="OK" className='themeButtons rounded-pill px-5 py-2 fw-bold' onClick={() => { setViewIndividualLab(false); setEditLabData({}) }} />
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default LaboratoryLists